/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CollectionPage = lazyLoad(
  () => import('./index'),
  module => module.CollectionPage
);
